module.exports = {
	"header": "Méthodes de paiement",
	"accepts": "$t(general::brand) accepte toutes les cartes de crédit majeures.",
	"addCard": "Ajouter une carte",
	"cardAdded": "Nouvelle carte ajoutée avec succès à votre compte.",
	"cardholderName": "Nom du détenteur",
	"creditCard": "Carte de crédit",
	"creditOrDebitCards": "Carte de débit ou de crédit",
	"creditCardNumber": "Numéro de carte de crédit",
	"cvc": "CVC",
	"defaultCard": "Carte par défaut",
	"editCardInfo": "Modifier l'information de la carte",
	"expiresOn": "Expire le",
	"nameOnCard": "Nom sur la carte",
	"noCard": "Aucune carte de crédit.",
	"sources": {
		"amex": "American Express",
		"bchq": "Chèque d'entreprise",
		"btra": "Transfert bancaire",
		"bdft": "Chèque bancaire",
		"cash": "Comptant",
		"cchq": "Chèque certifié",
		"disc": "Discover",
		"goog": "Google Checkout",
		"maet": "Maestro",
		"mast": "Mastercard",
		"pchq": "Chèque personnel",
		"pypa": "Paypal",
		"visa": "Visa",
		"wsun": "Western Union",
		"wtra": "Virement bancaire"
	},
	"sourceTypes": {
		"card": "Cartes de crédit",
		"other": "Autres"
	},
	"step": "Entrez l'information de votre carte de crédit (Étape __step__ de __totalSteps__)",
	"stripeErrors": {
		"incorrectNumber": "Ce numéro de carte est incorrect.",
		"invalidNumber": "Ce numéro de carte n'est pas un numéro valide de carte de crédit.",
		"invalidExpiryMonth": "Le mois d'expiration de la carte est invalide.",
		"invalidExpiryYear": "L'année d'expiration de la carte est invalide.",
		"invalidCVC": "Le code de sécurité de la carte est invalide.",
		"expiredCard": "La carte est expirée.",
		"incorrectCVC": "Le code de sécurité de la carte est incorrect.",
		"incorrectZip": "La validation du code postal / zip a échoué.",
		"cardDeclined": "La carte a été réfusée.",
		"default": "Une erreur est survenue lors du traitement de votre carte."
	},
	"updateCard": "Mettre la carte à jour"
}


//////////////////
// WEBPACK FOOTER
// /private/var/folders/n9/yczdnstj3wdc9q5tzm6d45c00000gp/T/maison-encans-auex-website/~/@auex/locales/lib/fr/paymentMethods.json5
// module id = 2003
// module chunks = 6